import {IJackpotBetsInfoModel} from "./jackpot-bets-info.model.interfeace";
import {IJackpotBetPrizeViewModel} from "./jackpot-bets-info.view-model.interface";
import JackpotBetsFeedRawDataInterface from "./jackpot-bets-feed-raw-data.interface";

export class VoidJackpotBetsInfoModel implements IJackpotBetsInfoModel {
    updateRawInfo(newRawInfo: JackpotBetsFeedRawDataInterface): void {
    }
    readonly winnersCount: number = 0;
    readonly  totalWinsToday: number = 0;
    readonly animatedTotalWinsToday: number = 0;
    getPrizes(): IJackpotBetPrizeViewModel[] {
        return [];
    }
}